const row = (
  Status,
  PrintProvider,
  Listing,
  OrderId,
  shopifyOrderPresentedID,
  BuyerName,
  OrderDate,
  TotalCost,
  TrackingNumber,
  vendorReferenceNumber
) => {
  return {
    Status,
    PrintProvider,
    Listing,
    OrderId,
    shopifyOrderPresentedID,
    BuyerName,
    OrderDate,
    TotalCost,
    TrackingNumber,
    vendorReferenceNumber,
  };
};

export { row };
